import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
}

/**
 * SpeakLemon icon mark — lemon with green speech bubble.
 * Renders inline SVG so it scales crisply at any size.
 */
export function BrandLogo({ className }: BrandLogoProps) {
  return (
    <svg
      viewBox="0 0 140 140"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-8 w-8", className)}
      aria-hidden="true"
    >
      {/* Lemon body */}
      <ellipse cx="70" cy="86" rx="52" ry="40" fill="#F5D020" />
      <ellipse cx="21" cy="86" rx="10" ry="7" fill="#F5D020" transform="rotate(-20 21 86)" />
      <ellipse cx="119" cy="86" rx="10" ry="7" fill="#F5D020" transform="rotate(20 119 86)" />
      <ellipse cx="55" cy="73" rx="16" ry="10" fill="#FAE96A" opacity="0.7" />
      {/* Speech bubble */}
      <rect x="85" y="30" width="44" height="30" rx="8" fill="#2E7D32" />
      <polygon points="96,60 86,76 108,60" fill="#2E7D32" />
      <line x1="95" y1="40" x2="95" y2="50" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
      <line x1="105" y1="36" x2="105" y2="54" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
      <line x1="115" y1="40" x2="115" y2="50" stroke="white" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}